module.exports = __webpack_public_path__ + "img/logo-light-2.c0e737ed.png";